import { useState } from 'react'

import { BlurApp, PageWrapper } from '@/shared'
import { type IUpdateAdminDto, type IAdmin } from '@App/types/adminsTypes'

import { type IEditAdmin } from '../../helper'

import { ConfirmRemoveModal } from './Item/ConfirmRemoveModal/ConfirmRemoveModal'
import { Item } from './Item/Item'
import style from './List.module.scss'

interface IProps {
    list: IAdmin[]
    onUpdateAdminCallback: (dto: IUpdateAdminDto) => void
    removableAdmin: string | null
    setRemovableAdmin: (removableAdmin: string | null) => void
    onRemoveAdmin: (adminId: string) => void
    onAddAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
    onRemoveAdminRole: (login: string, roleName: string, onSuccess: () => void) => void
    isFetchingAdmins: boolean
}

export const List = (props: IProps) => {
    const {
        list,
        onUpdateAdminCallback,
        setRemovableAdmin,
        removableAdmin,
        onRemoveAdmin,
        onAddAdminRole,
        onRemoveAdminRole,
        isFetchingAdmins
    } = props
    const [state, setState] = useState<IEditAdmin[]>(list.map((item) => ({ ...item, editMode: 'none' })))

    return (
        <PageWrapper>
            <ConfirmRemoveModal
                login={removableAdmin}
                onClose={() => setRemovableAdmin(null)}
                onRemoveAdmin={onRemoveAdmin}
            />
            <BlurApp show={state.some((item) => item.editMode !== 'none')} withScroll />
            <div className={style.container}>
                {state.map((admin, idx) => {
                    const { login } = admin
                    return (
                        <Item
                            key={login}
                            index={idx + 1}
                            setState={setState}
                            onUpdateAdminCallback={onUpdateAdminCallback}
                            setRemovableAdmin={setRemovableAdmin}
                            onAddAdminRole={onAddAdminRole}
                            onRemoveAdminRole={onRemoveAdminRole}
                            isFetchingAdmins={isFetchingAdmins}
                            {...admin}
                        />
                    )
                })}
            </div>
        </PageWrapper>
    )
}
